<template>
    <div class="container">
        <div class="row">
            <div class="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-offset-4 col-md-4 col-md-offset-4">
                <div class="login-panel panel panel-default">
                    <div class="panel-heading" style="text-align:center">
                      <h1>Dados Abertos</h1>
                        <h3 class="panel-title">
                          Registre sua nova senha
                        </h3>
                    </div>
                    <div class="panel-body">

                        <form role="form" @submit.prevent="salvarSenha()">

                            <fieldset>

                              <div class="form-group">
                                <label>Usuário</label>
                                  <input class="form-control" :placeholder="user" type="text" disabled />
                              </div>

                                <div class="form-group">
                                    <label>Senha</label>

                                    <input :class="['form-control', { 'is-danger': errors.has('password') }]" 
                                    v-model="model.password" v-validate="'required'" ref="password" placeholder="Senha" 
                                    name="password" type="password" />

                                    <span v-show="errors.has('password')" class="is-danger">

                                      <i class="fa fa-warning"></i>
                                      {{ errors.first('password') }}

                                    </span>

                                </div>

                                <div class="form-group">
                                    <label>Confirmar Senha</label>

                                    <input :class="['form-control', { 'is-danger': errors.has('confirmarSenha') }]" 
                                    v-model="model.confirm" v-validate="{ required:true, equals: [model.password, 'Senha'] }" ref="confirmarSenha" 
                                    placeholder="Confirmar senha" name="confirmarSenha" type="password" />

                                    <span v-show="errors.has('confirmarSenha')" class="is-danger">
                                      <i class="fa fa-warning"></i>
                                      {{ errors.first('confirmarSenha') }}
                                    </span>

                                </div>

                                <button class="btn btn-success btn-block" style="margin-bottom:10px" type="submit">Salvar senha</button>

                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import request from '@/request'

export default {
  name: 'registrarSenha',
  data () {
    return {
      user: '',
      model: {
        password: '',
        confirm: '',
        usu_token_first_access: ''
      }
    }
  },
  mounted () {
    if (!(this.$route.query.hasOwnProperty('token'))) {
      this.$toastr.e('Link invalido, solicite um novo link de cadastro de senha!')
      return
    }
    this.user = this.$route.query.user
    this.model.usu_token_first_access = this.$route.query.token
  },
  methods: {
    salvarSenha () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e('Verifique os campos obrigatórios estão preenchidos ou se a senhas conferem!')
          return
        }
      })
      request.post('user/registerpassword', this.model, this.saveSuccess, this.saveFail)
    },
    saveSuccess (result) {
      this.$toastr.s('Sua senha foi salva com sucesso.')
      this.$router.push({ name: 'login_user', params: { user: this.user } })
    },
    saveFail (result) {
      this.$toastr.e(result)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/RegistrarSenha.vue